module.exports = {
  global: {
    title:'Mobile Tv Management System',
    switch_lang:'简体中文',
    back_to_app_homepage:'Back to App Homepage',
    exit: 'Exit',
    save:'save',
    save_success:'Save success',
    icon:'icon',
    choose_image:'choose image',
    selected_icon:'icon for selected',
    add:'add',
    created:'created',
    start_time:'start time',
    end_time:'end time',
    duration:'duration',
    sort:'sort'
  },
  components:{
    common:{
      input_time:'Input time',
      add:'Add',
      tiao:'',
      check_all:'Check all',
    },
    tree:{
      placeholder:'Input keywords for filtering',
      nodata:'No data'
    },
    webuploader:{
      select_file:'Select file',
      upload_success:'Upload success',
      upload_failed:'Upload failed, please try again.',
    },
    container:{
      authority_management:'Authority management',
      barrage_management:'Barrage management',
      user_management:'User management',
      member_management:'Member management',
      gold_management:'Gold management',
      commodity_management:'Commodity management',
      log_management:'Log management',
      feedback:'Feedback',
      dibble_seeding_media_management:'Dibble seeding media management',
      live_media_management:'Live media management',
      config_management:'Configuration management',
      ad_management:'AD management',
      cdn_management:'CDN management',
      operations_management:'Operations management',
      system_settings:'System settings',
      chat_query:'Chat query',
      monitor_management:'Monitor management',
    },
    ooperatepanel:{
      search:'Search',
      empty:'Empty',
      filter_condition:'Filter condition',
    },
    popedit:{
      add_image:'Add image',
    },
    property_select:{
      more:'More',
      select:'Select',
    },
    tablepanel:{
      selected:'Selected ',
      check:'Check',
    },
    uploadfile:{
      upload_progress:'Upload progress',
      select_file:'Select file',
      upload_success:'Upload success',
      upload_failed:'Upload failed, please try again.',
    },
    vpage:{
      previous_page:'Previous',
      next_page:'Next',
      the:'The',
      page:'page',
      each_page:'Each page',
      total:'Total',
    },
    vselect:{
      input_search:' input search',
      empty:'Empty',
    }
  },
  cms:{
    ad:{
      common:{
        name:'name',
        ad_name:'Name of advertising',
        disable:'disable',
        start_using:'start using',
        operation:'operation',
        amend:'amend',
        del:'delete',
        remove:'remove',
        add:'add',
        seconds:'s',
        associated_ad:'Associated advertising',
        relevant_channel:'Associated channel',
        connected_channels:'Connected channels',
        live_channels:'Live Channels',
        creation_time:'Creation time',
        state:'state',
        choose:'choose',
        click_select:'Click on the select',
        send:'send',
        page:'page',
        page_screening:'Page screening',
        add_ad:'Add AD',
        add_ad_unit:'Add AD unit',
        series:'series',
        advertisers:'advertisers',
        set_time:'Time setting',
        content_customized_state:'Content customization（The IVA ads can be set for one channel or video respectively, which can be set respectively for the time period and the most flexible.）',
        volume_set_state:'Volume set（IVA ads with multiple contents are set up at the same time.）',
        send_instantly_state:'Send instantly（Send an IVA AD to a live channel immediately.）',
        intelligent_analysis_put_autonomy:'Intelligent analysis（Autonomy delivery）',
        effective_time:'Effective time',
        closing_time:'Closing time',
        sowing_start_time:'Start time after sowing',
        operation_platform:'Operation platform',
        relevance_app:'Relevance application',
        all:'all',
        ad_type:'AD types',
        put_scope:'Put on the scope',
        video_dibble_seeding:'Video dibble seeding',
        policy_type:'Policy type',
        show_length:'interval time',
        associated_resources:'Res-Relation',
        determine:'determine',
        occurrences:'occurrences',
        type:'type',
        channel:'channel',
        channel_name:'Name of the channel',
        ad_space_management:'Advertising space management',
        put_channel:'On the channel',
        ad_space_screening:'Advertising location screening',
        ad_space_name:'Name of advertisement location',
        ad_unit_control_amount:'AD unit control',
        configure_version:'Configure version',
        dibble_seeding:'dibble seeding',
        dibble_seeding_show:'dibble seeding programmes',
        live:'live',
        input_id_or_keyword:'Enter an id or keyword',
        select_file:'Select file',
        write_URL:'Fill in the URL',
        jump_type:'Jump type',
        app_name:'Application name',
        third_party_display_statistics:'Third party display statistics',
        third_party_click_statistics:'Third party click statistics',
        ad_page:'AD pages',
        ad_material:'AD material',
        set_time_quantum:'Modify the time period Settings',
        operator_ad:'Operator advertising',
        since_vote_ad:'Since the AD',
        time:'time',
        confirm_new:'Confirm the new',
        confirm_change:'Confirm the change',
        video_name:'Name of the video',
        episode_name:'Name of the episode',
        choose_show:'Choose to show',
        send_success:'send successfully',
        ad_unit_name:'Name of advertising unit',
        provider:'provider',
        config_control_amount:'Configuration control volume',
        batch_delete:'Batch delete',
        start_time:'start time',
        duration:'duration',
      },
      addconfig_add:{
        select_location_name:'Select location name',
        select_ad:'Choose advertising',
        select_version:'Select version'
      },
      adcontrol_add:{
        max_num_requests:'Maximum number of requests',
        min_num_show:'Maximum display number',
        min_num_click:'Maximum hits',
        start_time:'start time',
        end_time:'end of time',
        config_sort:'Configure the sorting'
      },
      adcontrol_list:{
        ad_control_amount:'Advertising volume control',
        ad_all_control_amount:'All advertising controls',
        add_putIn_equipment:'Increase placement',
        whether_disable:'Whether to disable',
        whether_reach_require:'Whether meet requirement',
        whether_overdue:'Is late',
        reach_require:'meet requirement',
        miss_require:'miss requirements',
        has_overdue:'expired',
        no_overdue:'No overdue',
        requestNum_or_maxRequestNum:'Number of requests/Maximum number of requests',
        showNum_or_maxShowNum:'Show the number/Maximum display number',
        clickNum_or_maxClickNum:'clicks/Maximum hits',
        overdue:'overdue'
      },
      adcustom_add:{
        compile_directMail:'Direct advertising editor',
        recommendedLanguage:'Recommended language',
        ad_present_time:'Advertising time(s)',
        ad_action:'Advertising action',
        click_jumpAdd:'Click the jump address',
        up_package:'Upload installation package',
        app_packageName:'Name of packages',
        write_telNum:'Fill in telephone number',
        click_describe:'Click on the description',
        describe:'describe',
        for_details:'For details',
        app_ad:'App advertising',
        img_ad:'Image ads',
        video_ad:'Video advertising',
        fullScreen_click:'Full screen click',
        adContent_click:'Ads content click',
        silent_install:'Silent installation',
        bound_install:'Bound to install',
        call_up:'Make a phone call',
        h5_external_links:'External H5 links',
        app_download_links:'App download link',
        system_call:'The system calls',
        no_turnOff:'Do not shut down',
        can_turnOff:'Can be closed'
      },
      adcustom_config:{
        video_title:'Video title',
        time_quantum_num:'Time period quantity'
      },
      adcustom_list:{
        direct_mail_ad_management:'Direct advertising management',
        put_broadcast_channel:'Live channel',
        put_dibble_seeding_video:'Put dibble seeding video'
      },
      add_stream_config:{
        period_time:'Period of time',
      },
      add_video_config:{
      },
      adiva_add:{
        IVA_add_set:'IVA advertising editor',
        position_size:'Position size',
        width:'width',
        height:'height',
        padding:'padding',
        align_edge:'Align edge',
        top:'top',
        bottom:'bottom',
        left:'left',
        reight:'reight',
        center:'center',
        lower_left:'left lower',
        jumpURL:'Jump the URL',
        ad_style:'Advertising style',
        intelligent_analysis_put:'Intelligent analysis（Yi + delivery）',
        scene_label:'Scene label',
        slide:'slide',
        lucency:'lucency'
      },
      adiva_config:{
      },
      adiva_list:{
        IVA_add_management:'IVA advertising management',
        unknown:'unknown',
        content_customized:'content customized',
        volume_set:'Volume set',
        send_instantly:'Send instantly',
        intelligent_analysis:'Intelligent analysis',
        put_autonomy:'autonomy put',
        launch_strategy:'launch strategy',
        change_basicInfo:'Modify basic information',
        IVA_ad:'IAV advertising'
      },
      adiva_recognition:{
        IVA_identification_taskList:'IVA identifies the task list',
        content_type:'Content type',
        show_name:'Series name',
        advertising_point:'Advertising point',
        result_count:'Result count',
        task_status:'Task status',
        cancel:'cancel',
        continue:'Continue',
        pause:'pause',
        stick:'Stick',
        retest:'retest',
        the:'the',
        episode:'episode',
        choose_tag:'choose tag',
        min_duration:'min duration',
      },
      adiva_strategy:{
        custom_launch_strategy:'Customized delivery strategy',
        policy_name:'Policy Name',
        dibble_seeding_show:'dibble seeding series'
      },
      adiva_tag:{
        IVA_adLabel_management:'IVA advertising label management.',
        label_name:'Label Name',
        label_tag:'Label Tags',
        choose_label_tag:'Select label classification'
      },
      adprovider_add:{
        select_advertisers:'Select advertisers',
        specify_application:'Specify the application',
        universal:'universal',
        dedicated:'dedicated',
        choose_app:'selected applications'
      },
      adprovider_list:{
        ad_provider:'Advertising provider',
        add_ad_provider:'Add advertising suppliers',
      },
      adunit_add:{
        choose_direct_mail_ad:'Choose direct advertising',
        operator_ad_provider:'Operator advertising provider',
        platform:'platform',
        operator_ad_bit_id:'Operator AD bit ID',
        ad_form:'advertisement form',
        direct_mail_ad:'AD is straight',
        iva_ad:'IVA advertising',
        ad_categories:'AD categories'
      },
      adunit_app:{
        ad_unit_association_app:'AD unit association application',
        app_type:'Application Type',
        associated_version:'Associated version',
        disassociation:'Disassociation'
      },
      adunit_control:{
      },
      adunit_list:{
        ad_unit_management:'Advertising unit management',
        new_ad_unit:'New advertising unit',
        app:'application',
        channel_choose:'Channel selection',
        territory:'territory'
      },
      adunit_setting_list:{
        ad_unit_set:'AD unit Settings',
        version_set:'Version of the set',
        global_set:'Global Settings',
        prompt:'*If the weights are set, the rules appear according to the weights',
        weight:'weight',
        ad_unit_id:'AD unit ID'
      },
      app_ad_channel:{
      },
      app_ad_list:{
        version:'version',
        association_ad_unit:'Associated AD unit'
      },
      appcontrol_list:{
      },
      channel:{
      },
      list:{
        ad_list:'Advertising list',
        new_ad:'New advertising',
        ad_unit_num:'Number of AD units',
        ad_placename:'AD placename',
        ad_unit:'AD unit'
      },
      push:{
        video_type:'Video type',
        creator:'creator'
      },
      select_custom:{
      },
      select_iva:{
      },
      update:{
        ad_space:'Advertising position',
        refresh_interval:'Refresh interval'
      },
      version:{
        already_relevant_version:'Associated version',
        platform_type:'Platform type',
        version_name:'VersionName',
        version_number:'version number'
      }
    },
    app:{
      common:{
        select:'select',
        confirm:'confirm',
        app_name:'APP Name',
        platform:'platform',
        package_name:'package name',
        all:'all',
        state:'state',
        enable:'enable',
        no_operation:'No operation',
        sort:'sort',
        ios_version:'ios version',
        android_version:'android version',
        support_language:'supported language',
        creation_time:'creation time',
        operation:'operation',
        compile:'compile',
        resource_management:'Resource management',
        version_management:'Version management',
        default_setting:'default setting',
        setting:'setting',
        delete:'delete',
        content_management:'Content management',
        choose_channel:'Choose channel',
        name:'name',
        use:'use',
        up_way:'Up way',
        bounced_up:'Bounced update',
        force_up:'Force update',
        version_set:'Version of the set',
        create_new_version:'Create a new version',
        version_number:'version number',
        copy_version:'Copy version',
        version_name:'Version name',
        installation_number:'installation number',
        version:'version',
        duplicate_content:'Duplicate Content',
        stop_maintenance:'Stop the maintenance',
        open_maintenance:'Open the maintenance',
        select_resource:'Select the resource',
        under_maintenance:'under maintenance',
      },
      language:{
        keywords:'keywords',
        language_name:'Language Name',
        local_name:'local name',
        abbreviation:'abbreviation',
      },
      list:{
        app_list:'APP List',
        new_app:'New app',
      },
      sdklist:{
        sdk_list:'SDK list',
        adk_name:'SDK name',
        new_sdk:'New sdk',
        add:'add',
        live_table_screen:'live table screen',
        play_page_banner:'Play page banner',
        play_banner:'Play banner',
        info_flow:'information flow',
        before_patch:'Before the patch',
        resource_group:'resource group',
        cdn_management:'CDN management',
        new_ad:'new advertising',
        old_ad:'old advertising',
      },
      select_market:{
        batch_add:'Batch add',
      },
      upgrade_detail:{
        version_config:'Version configuration',
        config_name:'Configuration Name',
        Select_upgrade_channels:'Select upgrade channels',
        reselect:'reselect',
        target_version:'Target version',
        system:'system',
        up_version:'upgrade version',
        upload_app:'Upload app',
        fill_url:'Fill in the URL',
        select_file:'Select File',
        Popup_msg:'Pop-up message content',
      },
      upgrade_list:{
        upgrade_management:'Upgrade management',
        new_upgrade_config:'New upgrade configuration',
        config_name:'Configuration Name',
        associated_channel:'Associated channel',
        disable:'disable',
        start_using:'start using',
        view_details:'view details',
      },
      version_sdk:{},
      version:{}
    },
    cdn:{
      common:{
        keyword:'keyword',
        category:'category',
        all:'all',
        select:'select',
        name:'name',
        antistop:'antistop',
        provider:'provider',
        domains:'domains',
        operation:'operation',
        add_domain:'Add Domain',
        instructions:'instructions',
        compile:'compile',
        del:'delete',
        batch_delete:'Batch delete',
        change:'change',
        related_video:'Related video',
        default_cdn_settings:'Default CDN Settings',
        cdn_set:'CDN set',
        num:'number',
      },
      addvideo:{
        add_existing:'Add existing',
        tv_play:'TV play',
        movie:'movie',
        video_name:'video name',
        batch_add:'batch add',
        determine:'determine',
      },
      global_cnd_list:{
        cdn_list:'CDN list',
        resource_number:'resource number',
      },
      global_default_setting:{
        default_global_cdn:'Default global CDN',
      },
      index:{},
      list:{
        resource_management:'Resource management',
        view_all:'View All',
      },
      update:{
        may_fill:'without not fill in',
        class_type:'class type',
      },
      video:{
        add:'add',
        the_current:'The current',
        title:'title',
        replace:'replace',
        remove:'remove',
        batch_replace:'Batch replace',
      }
    },
    common:{
      common:{
        name:'name',
        select:'select',
        creation_time:'creation time',
        operation:'operation',
        dibble_seeding:'dibble seeding',
        live:'live',
        classification:'classification',
        thumbnail:'thumbnail',
        state:'state',
        online:'online',
        offline:'offline',
        batch_add:'Batch add',
        confirm:'Confirm',
      },
      area_push:{
        select_territory_list:'select territory list',
        describe:'describe',
        shielding:'shielding',
      },
      cdn_group:{
        select_resource_group:'Select resource group',
      },
      content_config:{
        dibble_seeding_video:'dibble seeding video',
        live_channels:'Live Channels',
        add:'add',
        all_associated:'All associated',
        video_name:'video name',
        channel_name:'channel name',
        remove:'remove',
      },
      content_select:{
        sort_time:'Sort time',
        release_time:'release time',
        update_time:'Update time',
        synchronization_time:'Synchronization time',
        title:'title',
        publish_status:'publish status',
        artist:'artist',
        author:'author',
        current_shows:'Current shows',
        all_show:'All show',
        associated_song:'associated song',
      },
      epg_push:{
        select_show:'Select show',
        start_time:'start time',
        end_time:'end time',
      },
      property_select:{
        check_all:'check all',
        more:'more',
      },
      resource_group_copy:{
        resource_management:'Resource management',
      },
      resource_group_copys:{
        on_demand_resource_group:'On-demand resource group',
        live_resources_group:'Live resources group',
      },
      resource_group:{
        resource_group:'resource group',
        resource:'resource',
        broadcast:'broadcast',
      },
      stream_push:{
        choose_live:'Choose to live',
      },
      video_push:{
        choose_dibble_seeding:'Choose dibble seeding',
        alreadyhaveset_and_allset:'already have set/all set',
        type:'type',
      },
      broadcast_push:{
        choose_broadcast:'Choose broadcast',
      },
      rule_add:{
        channel_viewset:'Channel view set',
        area:'Area',
        user_name:'User name',
        area_select:'Through area select',
        crowd_select:'Through crowd select',
        shield:'Shield',
        allow_view:'Allow view',
        program:'Program',
        time_block:'Time block',
        start_time:'Start time',
        end_time:'End time',
        to:'to',
        select_program:'Select program',
        save:'Save',
        add_program:'Add program',
        select_date:'Select date',
        program_name:'Program name',
        date:'Date',
      },
      rule_push:{
        select_area:'Select area',
        select_crowd:'Select crowd',
        area_groupname:'Area group name',
        user_groupname:'User group name',
        area_groupid:'Area group id',
        explain:'Explain',
        user_groupid:'User group id',
        group_name:'Group name',
      }
    },
    content:{
      menu_name:'menu name',
      icon:'icon',
      choose_image:'choose image',
      sort:'sort',
      menu_list:'menu list',
      add_menu:'add menu',
      page:{
        name:'page name',
        client_name:'client name',
        alias:'alias',
        page_type:'page type',
        url:'URL',
        choose_library:'choose library',
        category:'category',
        page_type_show_page:'show page',
        page_type_mine:'mine',
        page_type_h5:'h5',
        page_type_library:'libaray'
      },
      commons:{
        recommended_words:'Recommended words',
        select_thwartwise_picture:'select thwartwise picture',
        select_vertical_picture:'select vertical picture',
        content_type:'content type',
        associated_content:'associated content',
        click_select:'Click on select',
        start_time:'start time',
        end_time:'end time',
        dibble_seeding_programmes:'dibble seeding programmes',
        live_channels:'Live Channels',
        enter_id_or_keyword:'Enter an id or keyword',
        name:'name',
        operation:'operation',
        choose:'choose',
        page_library:'Page library',
        all:'all',
        content_name:'content name',
        classify:'classify',
        alreadyhaveset_and_allset:'already have set/all set',
        cataloging_languages:'Cataloging languages',
        address:'address',
        ad:'AD',
        page:'page',
        new:'New',
        title:'title',
        type:'type',
        status:'status',
        start_use:'start using',
        disable:'disable',
        modification:'modification',
        delete:'delete',
        list:'list',
        display_mode:'Display mode',
        display_content:'display content',
        score:'score',
        id_or_name:'ID or name',
        all_categories:'All Categories',
        all_state:'All state',
        online:'online',
        offline:'offline',
        compile:'compile',
        category:'category',
        home_page:'Home page',
        live:'live',
        focus_picture:'focus picture',
        layout:'layout',
        automatic_filling:'Automatic filling',
        show:'show',
        not_show:'Not show',
        attribute:'attribute',
        without:'without',
        set:'set',
        player:'player',
        hot_search_list:'Hot search list',
        thumbnails:'thumbnails',
        ad_title:'AD title',
        ad_position:'AD position',
        ad_provider:'AD provider',
        guess_like:'Guess you like',
      },
      common:{
        pagegroup_add:{
          folder_name:'Folder name',
        },
        select_person:{
          characters:'characters',
          director:'director',
          actor:'actor',
        }
      },
      focus:{
        focus_bar_add:{
          figure:'figure',
        },
        focus_bar_list:{
          amend_focus_figure:'Amend focus figure',
          picture:'picture',
        }
      },
      gallary:{
        index:{
          library_page_set:'Library page setting',
          screening_items:'Screening items',
        },
        property_list:{
          confirm:'confirm',
          check_all:'check all',
        },
        setting:{
          list_set:'List Settings',
          first_column:'The first column',
          second_column:'The second column',
          third_column:'The third column',
          intro:'intro',
        }
      },
      menu:{
        menu_list:{
          content_management:'Content management',
        }
      },
      module:{
        module_list:{
          module_lists:'模块列表',
          add_module:'Add Module',
        }
      },
      section:{
        icon_section:{
          icon_list:'icon group',
        },
        section_add:{
          group_name:'Group Name',
          horizontal_tiled:'Horizontal tiled',
          vertical_tiled:'Vertical tiled',
          icon_group:'Icon group',
          icon_list:'Icon list',
          picture_scroll_interval:'Picture scroll interval',
          above_gap:'Above the gap',
          per_line_num:'Per line number',
          online_number:'online number',
          hot_sign:'Hot sign',
          select_resource_group:'Select resource group',
          title_right:'on the title right side',
          right_side_words:'Right side words',
          label:'label',
          expiration_time:'Expiration time',
          day:'day',
          real_media:'Real Media',
        },
        section_list:{
          group_list:'Group list',
          add_group:'Add Group',
        }
      },
      streampage:{
        index:{
          live_page_set:'Live page Settings'
        },
        mobile:{
          programme_bill:'Programme bill',
          chat:'Have a chat',
        }
      },
      topsearch:{
        index:{
          search_page_set:'Search page Settings',
          search_box:'search box',
        },
        setting:{
          hot_search_title:'Hot search title'
        }
      },
      video:{
        video_bar_add:{
          related_series:'Related series',
          cover:'cover',
          hottest_live:'The hottest live',
          latest_live:'The latest live',
          select_content_type:'Select the content type',
        },
        video_bar_form:{
          video_list_modification:'Video list modification',
          column:'column',
        },
        video_bar_list:{
          content_editing:'Customize dibble seeding content editing',
          film_title:'film title',
          dibble_seeding:'dibble seeding',
          series:'series',
        }
      },
      videopage:{
        index:{
          dibble_seeding_page_set:'dibble seeding page setting',
        },
        like:{
          associated_ad:'Associated advertising',
        },
        mobile:{
          choose_episode:'Choose episode',
          film_intro:'film intro',
        },
        player:{
          player_ad:'Player advertising',
          front_screen_ad:'Front screen advertising',
          play_banner:'Play banner',
          exit_ads:'Exit ads',
          play_loading:'Play loading',
          preface_ad:'Preface advertising',
        }
      },
      copy_page:{
        all_versions:'All Versions',
        all_platforms:'All platforms',
        page_name_alias:'Page name or alias',
        version:'version',
        platform:'platform',
        page_alias:'Page alias',
        synchronization:'synchronization',
        synchronous_success:'Synchronous success',
      },
      index:{
        clients_set:'Clients Settings',
        copy_pages:'copy pages',
        successfully_delete:'successfully delete',
        config_page:'Configuration page',
      },
      property:{
        add:'add',
        coding:'coding',
        identity:'identity',
      },
      title_bar_form:{
        title_bar_set:'Title bar setting',
        upload_pictures:'upload pictures',
      }
    },
    contentbind:{
      common:{
        series_matching:'The series matching',
        video_name:'Video name',
        corresponding_video:'Corresponding video',
        status:'status',
        all:'all',
        matched:'The matched',
        not_match:'Did not match',
        operation:'operation',
        modification:'modification',
        choose:'choose',
        source_operator:'Source operator',
        mobile_name:'Mobile TV channel name',
        remove_match:'Remove the match',
      },
      episode_list:{
        series_name:'series name',
        matching_situation:'matching situation',
        mobile_tv_series:'Mobile TV series',
      },
      stream_list:{
        live_content_matching:'Live content matching',
        channelname:'channel name',
        corresponding_channel:'The corresponding channel',
        mobile_number:'Mobile TV channel number',
      },
      video_list:{
        dibble_seeding_matching:'Dibble seeding content matching',
        dibble_seeding_video:'Dibble seeding video',
        video_matching:'Video matching',
        mobile_video_number:'Mobile TV video number',
        mobile_dibble_seeding_type:'Mobile TV dibble seeding type',
        check_series:'Check series',
        movie:'movie',
        tv_play:'TV play',
      }
    },
    mmsprovider:{
      list:{
        media_server_management:'Media server management',
        add:'add',
        server_name:'Server name',
        server_address:'Server address',
        type:'type',
        synchronous_cycle:'Synchronous cycle(s)',
        operation:'operation',
        modification:'modification',
        del:'delete',
      }
    },
    recommend:{
      category_list:{
        list:'Category Management',
        name:'Category Name',
        type:'Type',
        recommend:'Recommend',
        recommend_count:'Recommend Count',
      },
      recommend_list:{
        refresh:'refresh',
        sort:'sort',
      }
    },
    notify:{
      common:{
        dibble_seeding_programmes:'Dibble seeding programmes',
        live_channels:'Live Channels',
      },
      edit:{
        push_editor:'Push the editor',
        new_theme:'New theme',
        message_content:'Message content',
        push_type:'Push type',
        system_message:'System message',
        dibble_seeding:'Dibble seeding',
        live:'live',
        push_page:'Push page',
        click_select:'Click to select',
        push_version:'Push version',
        associated_channel:'Associated channel',
        push_object:'Push object',
        unlimited:'unlimited',
        select_push:'Select the push',
        select_not_push:'Select not push',
        regional_group:'Regional group',
        push_time:'Push the time',
        immediately_send:'Immediately send',
        regularly_send:'Regularly send',
        user_group:'User Group',
      },
      list:{
        message_list:'Message list',
        new_message:'New message',
        serial_number:'Serial number',
        title:'title',
        channel:'channel',
        state:'state',
        add_time:'Add time',
        send_time:'Send time',
        operation:'operation',
        compile:'compile',
        del:'delete',
        not_push:'Not push',
        have_push:'Have to push',
      },
      statistics:{
        notify_statistics:'notify statistics',
        transmissions:'transmissions',
        deliveries:'deliveries',
        clicks:'clicks',
        impressions:'impressions',
        expire:'expire time',
        content_type:'content type',
        content_title:'content title',
      }
    },
    resource_group:{
      commons:{
        add_resource_group:'Add resource group',
        live_channel:'Live channel',
        choice:'Choice',
        operation:'Operation',
      },
      common:{
        preview:{
          protagonist:'protagonist',
          director:'director',
          synopsis:'synopsis',
          series_list:'Series list',
          clarity:'clarity',
          original_video:'Original video',
        }
      },
      episode_list:{
        add_series:'Add series',
        sort_save:'sort save',
        modify_series:'Modify series',
        preview:'preview',
        transcoding_again:'Transcoding again',
        delete_respective_series:'Delete respective series',
        done:'done',
        waiting_transcoding:'Waiting for transcoding',
        is_transcoding:'Is transcoding',
        transcoding_failure:'Transcoding failure',
        transcoding_suspend:'Transcoding to suspend',
        transcoding_complete:'Transcoding to complete',
        unknown_state:'Unknown state',
      },
      group_add:{
        new_resource_group:'New resource group',
      },
      group_list_tree:{
        delete_resource_group:'Delete resource group',
      },
      group_list:{
        system_group:'System group',
        app_group:'App group',
        all:'all',
        not_grouped:'Not grouped',
      },
      stream_share:{
        live_share:'Live sharing',
        add:'Add',
        live_share_head:'Live sharing headlines',
        notice_time:'Notice start time',
        live_share_time:'Live sharing time',
        jump_url:'Jump Url',
        live_share_icon:'Live sharing icon',
        recommended_words:'Recommended words',
        limited_character_number:'Limited character number ',
        total:'Total',
        not_begin:'Not beginning',
        appointment:'Appointment',
        broadcast_live:'Being broadcast live',
        finished:'Finished',
        add_time:'Add time',
        active_state:'Active state',
        edit:'Edit',
        delete:'Delete',
      },
      stream_share_add:{
        click_select:'Click selection',
        local_upload:'Local upload',
        save:'Save',
        to:' to ',
      }
    },
    stream:{
      common:{
        name:'name',
        select:'select',
        start_time:'start time',
        operation:'operation',
        territory_set:'territory set',
        del:'delete',
        have_published:'Have published',
        has_withdrawn:'Has withdrawn',
        deleted:'deleted',
        draft:'draft',
        channel_name:'channel name',
        all:'all',
        online:'online',
        offline:'offline',
        state:'state',
        creation_time:'Creation time',
        conditional_type:'Conditional type',
        conditional_detail:'Conditional detail',
        shield_allow_view:'Shield/Allow view',
        end_time:'End time',
        state:'State',
        operation:'Operation',
        del:'Delete',
        select_object:'Select object',
        shield_allow:'Shield/Allow',
        time:'Time',
        area:'Area',
        crowd:'Crowd',
        allow_view:'Allow view',
        shield:'Shield',
        effective:'Effective',
        finished:'Finished',
        not_started:'Not started',
        batch_del:'Batch del',
      },
      area_push:{
        territory_shielding:'Territory shielding',
        shielding:'shielding',
      },
      epg_list:{
        programme_menu:'Programme menu',
        program_name:'program name',
        selection_time:'selection time',
        watch_limit:'Watch limit',
        member_set:'Member set',
      },
      list:{
        live_video_library:'Live video library',
        add_existing_channels:'Add existing channels',
        all_state:'All state',
        whether_association:'Whether association ',
        barrage:'barrage',
        open:'open',
        shut_down:'Shut down',
        shielding_set:'Shielding set',
        view_source:'View Source',
        program_menu_set:'Program menu Settings',
        program_menu:'Program menu',
        open_barrage:'Open barrage',
        close_barrage:'Close barrage',
        channel_set:'channel set',
        timeblock_set:'timeblock set',
      },
      push:{
        add_have_already_live:'Add have already live',
        live_name:'Live name',
        video_type:'Video type',
        creator:'creator',
        batch_add:'Batch add',
      },
      setting:{
        player:'player',
      },
      source_list:{
        live_source_list:'Live source list',
        fluency:'fluency',
        standard_definition:'standard definition',
        high_definition:'high definition',
        ultra_high_definition:'ultra high definition',
        source_name:'source name',
        sharpness:'sharpness',
        bit_rate:'Bit rate',
        address:'address',
        proportion:'proportion',
        share:'share',
        preview:'preview',
        shareable:'Shareable',
        not_sharable:'can not share',
        is:'is',
        no:'no',
      },
      timeblock_list:{
        shielding_management:'shielding management',
        add:'add',
        program_shielding:'Program shielding',
        time_shielding:'Time shielding',
        end_time:'end time',
        select_program:'Select program',
        modification:'modification',
      },
      channel_set:{
        view_set:'view set',
        add_view_set:'Add view set',
      },
      time_set:{
        time_set:'time set',
        add_set:'Add set',
        setup_mode:'Setup mode',
        program_name:'Program name',
        select_program:'Select program',
        program:'Program',
        time_block:'Time block',
      }
    },
    system:{
      common:{
        add:'add',
        start_time:'start time',
        end_time:'end time',
        live_channels:'Live Channels',
        operation:'operation',
        compile:'compile',
        del:'delete',
        edit_territory_group:'edit territory group',
        submit:'submit',
        territory_group_name:'territory group name',
        territory_group_explain:'territory group explain',
        territory_select:'territory select',
        waiting_choice:'Waiting for choice',
        have_chosen:'have chosen',
        creation_time:'Creation time',
      },
      activity_list:{
        tv_red_envelope_setting:'TV red envelope setting',
        select_version:'Select version',
        selected_channel:'Selected channel',
        title:'title',
        version:'version',
        channel:'channel',
        dibble_seeding_video:'dibble seeding video',
        associated_content:'Associated content',
      },
      area_edit:{
        refresh:'refresh',
      },
      area_list:{
        territory_group_management:'territory group management',
        create_new_territory_group:'create new territory group',
        select:'select',
        name:'name',
        explain:'explain',
        batch_delete:'Batch delete',
      },
      provider_list:{
        provider_management:'Provider Management',
        provider:'provider',
        video_count:'Video Count',
        channel_count:'Channel Count',
        choose_channel:'Choose Channel'
      },
      channel_list:{
        channel_management:'Channel management',
        channel_name:'Channel name',
        alias:'alias',
        platform:'platform',
        installation_number:'Installation number',
        Cumulative_publish_versions:'Cumulative publish versions',
        latest_version:'latest version',
      },
      schedule_list:{
        dibble_seeding_timing_task:'dibble seeding timing task',
        live_timing_task:'live timing task',
        add_timing_task:'add timing task',
        all_dibble_seeding_video:'all dibble seeding video',
        all_live_programmes:'All live programmes',
        task_type:'Task type',
        content_type:'Content type',
        state:'state',
        running:'running',
        suspend:'suspend',
        modification:'modification',
      },
      streamevent_list:{
        activity_live_sharing:'activity live sharing',
        activity_live_name:'activity live name',
        publicity_pictures:'Publicity pictures',
        trailer_start_time:'trailer start time',
        live_start_time:'Live start time',
        live_end_time:'Live end time',
        click_select:'Click select',
        active_state:'Active state',
        add_time:'add time',
      }
    },
    video:{
      common:{
        territory_shield:'territory shield',
        name:'name',
        select:'select',
        shielding:'shielding',
        territory_set:'territory settings',
        selected_name:'selected name',
        member:'member',
        not_member:'not member',
        downloadable:'downloadable',
        not_download:'Do not download',
        creation_time:'Creation time',
        operation:'operation',
        preview:'preview',
        all:'all',
        online:'online',
        offline:'offline',
        state:'state',
      },
      area_push:{
        shielding_territory:'shielding territory',
        select_territory_plan:'select territory plan',
        series_name:'series name',
      },
      area_select:{
        confirm:'confirm',
      },
      area:{
        users_block:'Users block',
        batch_shielding:'Batch shielding',
        batch_through:'Batch through',
      },
      cms_video_list:{
        dibble_seeding_video:'dibble seeding video',
        add_video:'add video',
        recommend_words:'recommend words',
        just_look_current_folder:'Just look at the current folder',
        view_all:'View all',
        id_or_name:'ID or Name',
        all_state:'All state',
        classification:'classification',
        language:'language',
        all_episode:'all episode',
        barrage:'barrage',
        ad:'Advertisement',
        open:'open',
        shut:'close',
        view_details:'view details',
        open_barrage:'Open barrage',
        close_barrage:'Close barrage',
        open_ad:'Open Advertisement',
        close_ad:'Close Advertisement',
        removed_from:'removed from',
        stop_selling:'Stop selling',
        is_selling:'Is selling',
        video_view_set:'Regional management',
      },
      detail:{
        video_details:'video details',
        submit:'submit',
        all_member_types:'All member types',
        all_download_types:'All download types',
        onoff:'ONOFF',
        share_status:'Share status',
        shareable:'Shareable',
        not_share:'Do not share',
        member_type:'Member type',
        download_type:'download type',
        download_set:'Download Settings',
        sharing_set:'Sharing Settings',
        batch_online:'Batch online',
        batch_offline:'Batch offline',
        batch_sharing_setup:'Batch sharing setup',
        batch_download_settings:'Batch download Settings',
        batch_territory_settings:'Batch territory Settings',
        view_set:'View set',
        bit_set:'bitrate set',
        wait_bit:'wait bitrate',
        selected_bit:'selected bitrate',
      },
      preview:{
        sharpness:'sharpness',
        synopsis:'synopsis',
        series_list:'series list',
      },
      push:{
        add_existing_dibble_seeding:'Add existing dibble seeding',
        live_name:'live name',
        video_type:'Video type',
        creator:'creator',
        batch_add:'Batch add',
      },
      view_set:{
        view_set:'view set',
        add_set:'Add view set',
        create_time:'Create time',
        conditional_type:'Conditional type',
        conditional_detail:'Conditional detail',
        shield_allow_view:'Shield/Allow view',
        start_time:'Start time',
        end_time:'End time',
        state:'State',
        operation:'Operation',
        del:'Delete',
        select_object:'Select object',
        shield_allow:'Shield/Allow',
        time:'Time',
        area:'Area',
        crowd:'Crowd',
        allow_view:'Allow view',
        shield:'Shield',
        effective:'Effective',
        finished:'Finished',
        not_started:'Not started',
        batch_del:'Batch del',
        content_ID:'content ID',
        content_type:'content type',
      }
    },
    broadcast:{
      list:{
        title:'broadcast library',
        broadcast_name:'broadcast name',
        all_state:'all state'
      }
    }
  },
  admin:{
    common:{
      real_name:'Real name',
      role_group_name:'Role group name',
      operation:'operation',
      compile:'compile',
      del:'delete',
    },
    addaccount:{
      new_account_role:'New account role',
      user_name:'user name',
      password:'password',
      email:'email',
      phone_number:'phone number',
      select_role_grouping:'Select role grouping',
      set_new_password:'Set new password',
    },
    addrole:{
      modification:'modification',
      new:'new',
      account_role:'Account role',
      copyright_explain:'copyright explain',
      edit_permission:'edit permission',
    },
    adminlist:{
      account_management:'Account management',
      new_account:'New account',
      grouping:'grouping',
      account_name:'account name',
      group:'group',
      phone:'phone',
    },
    modules:{
      all_permissions:'All permissions',
      add_module:'Add module',
      method_name:'Method name',
      parent_module:'parent module',
      subordinate_module:'Subordinate to the module',
      search_module:'Search module',
      name:'name',
      module:'module',
    },
    rolelist:{
      role_group_management:'Role group management',
      new_role_group:'New role group',
      explain:'explain',
      number_characters:'Number of characters',
      app_management:'App management',
      sdk_management:'SDK management',
    }
  },
  bigdata:{
    common:{
      channel_statistics:'Channel statistics',
      name:'name',
      ad_types:'AD types',
      advertisers:'advertisers',
      channel:'channel',
      times_play:'times of play',
      running_time:'running time',
      play_user:'Play the user',
      search_times:'search times',
      comment_times:'comment times',
      collect_times:'collect times',
      amount_downloads:'amount of downloads',
      start_time:'start time',
      end_time:'end time',
      users_retained:'Users of retained',
      new_user:'new user',
      activate_user:'activate user',
      start_up_time:'start-up time',
      gross:'gross',
      version:'version',
      according_hours:'According to the hours',
      according_date:'According to the date',
      according_week:'According to the week',
      according_month:'According to the month',
      select_time:'select time',
      platform:'platform',
      channel:'channel',
      time:'time',
      channel_name:'channel name',
      channel_category:'Channel category',
      belongs_cp:'Belongs to CP',
      operation:'operation',
      detailed_data:'Detailed data',
      new_users:'New users',
      new_users_ratio:'New users ratio',
      unfold_screening:'unfold screening',
      pack_up_screening:'pack up screening',
      num:' ',
      use_flowrate:' use flowrate',
      video:'video',
      video_name:'video name',
      flowrate:'flowrate',
      video_category:'video category',
      language:'language',
      date:'date',
      view_program:'view program',
    },
    ad:{
      adplace_summary:{
        channel:'Channel',
      },
      unit_summary:{
        ad_unit_statistics:'AD unit statistics',
        ad_unit:'AD unit',
        type:'type',
        requests_number:'Number of requests',
        request_successful:'request is successful',
        request_failed:'request failed',
        request_timeout:'request timeout',
        request_success_before_timeout:'Request success before timeout',
        request_failed_before_timeout:'Request failed before timeout',
        exposure:'exposure',
        click:'click',
        fill_rates:'Fill rates',
        exposure_rate:'Exposure rate',
        click_rate:'Click rate',
      }
    },
    basic:{
      app_summary:{
        app_general_situation:'APP general situation',
        today:'Today',
        yesterday:'Yesterday',
        error_rate:'Error rate',
        recent7:'(recent7)',
        first_use:'first use',
        the:'The',
        day:'day',
        per_capita_startup_times:'Per capita startup times',
        duration_each_use:'Duration time of each use',
        duration_per_person:'Duration time of per person',
        app_name:'APP name',
        category:'category',
      },
      user_active:{
        active_user_analysis:'Active user analysis',
        active_users:'Active users',
        active_users_ratio:'Active users ratio',
      },
      user_area:{
        terrain_analysis:'terrain analysis',
        region:'region',
      },
      user_channel:{
        channel_analysis:'Channel analysis',
        channel_name:'Channel name',
        average_length:'Average length of use',
      },
      user_client:{
        analysis_terminal:'terminal analysis',
        equipment_type:'equipment type',
        operating_system:'operating system',
        resolution_ratio:'resolution ratio',
        operator:'Operator',
        networking_way:'Networking way',
      },
      user_new:{
        new_user_ratio:'new user ratio',
      },
      user_remains:{
        first_use_date:'First use date',
        day_later:'days later',
      },
      user_summary:{
        user_analysis:'User analysis',
      }
    },
    network_traffic:{
      stream_summary:{
        qualifying_channels:'Qualifying channels',
      },
      video_summary:{
        dibble_seeding_flowrate_statistics:'dibble seeding flowrate statistics',
        eligible_video:'eligible video',
      }
    },
    stream:{
      stream_channel_summary:{
        channel_analysis:'Channel analysis',
      },
      stream_program_summary:{
        program_statistics:'program statistics',
        program_name:'program name',
        subordinate_channel:'Subordinate to the channel',
      }
    },
    video:{
      video_drama_summary:{
        video_statistics:'Video statistics',
      },
      video_episode_summary:{
        statistics_series:'Statistics series',
        series:'series',
        series_name:'series name',
      },
      video_summary:{
        dibble_seeding_statistics:'dibble seeding statistics',
        check_series:'Check the series',
      }
    }
  },
  config:{
    common:{
      new:'new ',
      name:'name',
      upload_pictures:'upload pictures',
      describe:'describe',
      top_left_corner:'top left corner',
      top_right_corner:'top right corner',
      lower_left_corner:'lower left corner',
      lower_right_corner:'lower right corner',
      creation_time:'Creation time',
      operation:'operation',
      compile:'compile',
      delete:'delete',
      local_name:'local name',
      abbreviation:'abbreviation',
      picture:'picture',
      figure:'figure',
      gender:'gender',
      identity:'identity',
      head_portrait:'head portrait',
      english_name:'English name',
      countries:'countries',
      date_birth:'date of birth',
      alias:'alias',
      actor:'actor',
      director:'director',
      man:'man',
      woman:'woman',
      type:'type',
      language:'language',
      program_name:'program name',
      new_label:'new label',
      label_name:'label name',
      num:'number',
      relevance_dibble_seeding_number:'relevance dibble seeding number',
      relevance_dibble_seeding_video:'relevance dibble seeding video',
      role_name:'name',
      width:'width',
      height:'height',
      video_bitrate:'Video bitrate',
      audio_bitrate:'Audio bitrate',
      default:'default ',
      fastest_speed:'Fastest speed',
      velocity_priority:'Velocity priority',
      dynamic_equilibrium:'Dynamic equilibrium',
      image_quality_priority:'Image Quality Priority',
      optimal_quality:'Optimal quality',
      location:'location',
    },
    cp:{
      list:{
        management:' management',
        new:'new ',
        address:' address',
      }
    },
    language:{
      list:{
        Catalog_language_management:'Catalog language management',
        new_language:'new language',
      }
    },
    person:{
      add:{
        author:'author',
        artist:'artist',
      },
      list:{
        people_management:'People management',
        new_figures:'new figures',
        figures_type:'figures type',
      },
      star:{
        star_management:"Star management",
        star_name:"star name",
      }
    },
    ressetting:{
      res_setting:{
        resource_default_config:'Resource default configuration',
        save_refresh:'Save and refresh',
        dibble_seeding_set:'dibble seeding set',
        video_up_down_line_set:'Video up and down line Settings',
        default_referrals:'Default referrals',
        default_online:'Default online',
        series_up_down_set:'series is set up and down',
        default_download_set:'Default download Settings',
        not_download:'Do not download',
        downloadable:'Downloadable',
        default_sharing_set:'Default sharing Settings',
        not_share:'Do not share',
        shareable:'Shareable',
        default_comment_set:'Default comment setting',
        default_line_code_rate:'Default line code rate',
        waiting_select:'waiting select',
        selected:'selected',
        code_rate_online_number:'Number of code rate on-line',
        all_code_rate:'All code rate',
        fixed_quantity:'Fixed quantity',
        live_set:'Live set',
        up_down_set:'Up and down set',
        default_set:' default setting',
        not_comment:'Do not comment',
        can_comment:'Can comment',
        radio_set:'Radio set',
      }
    },
    tags:{
      attr_add:{
        property_name:'property name',
        unknown:'unknown',
        ordinary:'ordinary',
      },
      bind_add:{
        program_key:'Program key',
        select:'select',
        relevance_all_selected:'Relevance all selected',
      },
      bind_list:{
        relevance_dibble_seeding_program:'relevance dibble seeding program',
        add_relevance:'add relevance',
        program:'program ',
        cancel_relevance:'cancel relevance',
      },
      category_list:{
        categories_management:'categories management',
        new_categories:'new categories',
        categories_name:'categories name',
      },
      container:{
        delete_attribute:'Delete Attribute',
        add_new_attribute:'Add New Attribute',
      },
      content_list:{
        content:'content',
        label_code:'Label code',
      },
      general_list:{
        label_management:'Label management',
      },
      person_add:{
        new_account_role:'New account role',
      },
      person_list:{
        figure_labels:'Figure labels',
        new_figures:'new figures',
        nationality:'nationality',
      }
    },
    transcodeconfig:{
      add:{
        new_transcoding_scheme:'New transcoding scheme',
        config_name:'Configuration Name',
        example:'For example:500K high definition (800K) superclear (1000K)',
        unit:'Unit is K',
        bitrate_introduce:'Commonly used audio code rates 48K, 64K, 128K; the rate is not filled or 0 is the prohibition of output audio or video',
        video_format:'Video format',
        frame_rate:'Frame rate',
        frame_spacing:'Frame spacing',
        frame_number:' frame number',
        frame_introduce:'-1: close the B frame, 0: no number, the rest: set a fixed number',
        bitrate_type:'Bit rate type',
        coding_rule:'Coding rule',
        code_level:'Code level',
        transcoding_strategy:'Transcoding strategy',
        variable_bitrate:'variable bitrate',
        constant_bitrate:'constant bitrate',
      },
      list:{
        transcoding_scheme_management:'Transcoding scheme management',
        new_transcoding_scheme:'New transcoding scheme',
        strategy:'strategy',
        submit_time:'Submit time',
      }
    },
    translation:{
      list:{
        translation_management:'Translation management',
        new_translation:'New translation',
        original:'original',
        old_name:'old name',
        translate:'translate',
      }
    },
    watermark:{
      add:{
        new_watermarking:'new watermarking',
        margin:'margin',
        level:'level',
        vertical:'vertical',
      },
      list:{
        watermark_management:'Watermark management',
        new_watermark:'new watermark',
        scenario_name:'scenario name',
        level_margin:'level margin',
        vertical_margin:'vertical margin',
      }
    }
  },
  ims:{
    common:{
      whether_barrage_allowed:'Whether the barrage is allowed',
      all:'all',
      yes:'yes',
      no:'no',
      sorting_by_barrage_num:'Sorting by barrage number',
      channel:'channel',
      name:'name',
      barrage_number:'Barrage number',
      operation:'operation',
      management_barrage:'Management barrage',
      unfinished:'unfinished',
      online:'online',
      offline:'offline',
      user_name:'user name',
      head_portrait:'Head portrait',
      pass:'pass',
      shield:'shield',
      warning:'warning',
      state:'state',
      keywords:'keywords',
      select:'select',
      release_time:'release time',
      content:'content',
      video_name:'video name',
      issuer:'issuer',
      cause:'cause',
      review_through:'Review through',
      join_blacklist:'Join the blacklist',
      batch_shielding:'Batch shielding',
      batch_through:'Batch through',
      allow_user_comment:'Allow the user to comment',
      forbidden_comment:'It is forbidden to comment on the user',
      close_barrage:'Close the barrage',
      open_barrage:'Open the barrage',
      column_name:'column name',
      sensitive_words:'Sensitive words',
      illegal_words:'Illegal words',
      submit:'submit',
      amend:'amend',
      del:'delete',
      release_shielding:'Release shielding',
      platform:'platform',
      selection_time:'selection time',
      nickname:'nickname',
      name_mother_tongue:'Name mother tongue',
      user_id:'user id',
      serial_number:'Serial number',
      trading_hours:'Trading hours',
      transaction_type:'Transaction type',
      user_name_id:'User name or id',
      out_account:'Out of account',
      into_account:'Into account',
      balance:'balance',
      transaction_name:'Transaction name',
      goods_order:'Goods order',
      member_order:'Member order',
      page_recharge_order:'Page recharge order',
      unknown_type:'Unknown type',
      selection_platform:'selection of platform',
      affiliate_purchases:'Affiliate purchases',
      take_effect:'take effect',
      already_down:'Already down',
      package_id:'Package id',
      package_name:'Package name',
      original_price:'original price',
      shelf_time:'Shelf time',
      check_details:'Check the details',
      off_shelf:'Off the shelf',
      compile:'compile',
      is_effect:'Is to take effect',
      sign_time:'sign time',
      disable:'disable',
      start_using:'start using',
      blacklist:'blacklist',
      normal:'normal',
      phone_number:'phone number',
      user_type:'user type',
      gold_balance:'gold balance',
      speeches_number:'Number of speeches',
      banned_state:'Banned state',
      enabled:'enabled',
      cancel_banned:'Cancel banned',
      banned:'Banned',
      use_activation_code:'Use activation code',
      activation_code_use_success:'Activation code is used successfully!',
      activation_code_failed:'Activation code is used failed, please try again!',
      vip_user:'VIP user',
      average_user:'average user',
      release_blacklist:'Release the blacklist',
      all_statements:'All statements',
      activation_code:'Activation code',
      white_list_Set:'User white list Settings',
      add:'add',
      installation_id:'Installation ID',
      explain:'explain',
      join_white_list:'Join the white list',
      generate_number:'generate number',
      new_activation_code:'New activation code',
      upload_pictures:'upload pictures',
      package_instructions:'Package instructions',
      upper_lower_frame:'Upper and lower frame',
      selling_status:'Selling status',
      selling:'Selling',
      putaway:'putaway',
      bindings:'Bindings',
      current_state:'current state',
      expired:'Expired',
      level:'level',
      new:'new',
      welfare_name:'welfare name',
      captions:'captions',
      remaining_days:'remaining days',
      member_transaction_record:'Member transaction record',
      user_list:'User list',
      live_watch_time:'Live watching time',
      stream_watch_time:'Stream watch time',
      barrage_number:'Number of barrage',
      purchase_amount:'VIP purchase amount',
      sign_days:'Sign days',
    },
    barrage:{
      channellist:{
        channel_details:'channel details',
        channel_keyword:'Enter the channel keyword',
        channel_id_sorting:'Channel ID sorting',
      },
      commentmanage:{
        new_barrage:'New barrage',
        create_user:'Create user',
        please_select_program:'Please select program',
        barrage_time_point:'Barrage time point',
        after_start_program:'(After the start of the program H:M:S)',
        send:'send',
        city:'city',
        real_time_monitoring:'real time monitoring',
        shielding_barrage:'Shielding barrage',
        delete_blacklist:'Delete blacklist',
        channel_barrage:'Channel barrage',
        column_barrage:'Column barrage',
        all_barrage:'All barrage',
        select_user:'Please select a user',
        comment_success:'Comment on success!',
        comments_failed:'Comments failed, please try again!',
        users_create_success:'New users create success!',
        user_creation_failed:'New user creation failed, please try again!',
      },
      commentswitch:{
        barrage_switch_management:'Barrage switch management',
        column:'column',
        enter_channel_keyword:'Enter the channel keyword',
        whether_not:'Whether or not ',
        classification:'classification',
        series_shielding:'series shielding',
        enter_column_keywords:'Enter the column keywords',
      },
      episodetable:{
        batch_closed:'Batch closed',
        batch_open:'Batch open',
      },
      keywordalarm:{
        Keyword_alarm_processing:'Keyword alarm processing',
        publish_content:'Publish content',
        review_status:'Review status',
        alarm_type:'Alarm type',
        pass_examination:'pass the examination',
      },
      keywordmanage:{
        keyword_management:'Keyword management',
        type:'type',
        search_keywords:'Search keywords',
        add_keywords:'Add keywords',
        batch_import:'Batch import',
        add_time:'add time',
        import_success:'Import success!',
        import_failure:'Import failure, please try again!',
        select_csv_file:'Please select the CSV file',
      },
      programlist:{
        column_details:'Column details',
        column_type:'Column type',
        enter_column_keyword:'Enter the column keyword',
        Sort_column_creation_time:'Sort by column creation time',
        column_id:'column id',
      },
      realtimecomment:{
        users_remove_blacklist:'Users remove the blacklist',
        users_join_blacklist:'Users join the blacklist',
      },
      usercommentlist:{
        all_user_statements:'All user statements',
      }
    },
    feedback:{
      list:{
        device_id:"device id",
        feedback_problems:'Feedback problems',
        replied:'replied',
        unanswered:'Unanswered',
        read_no_reply:'Read no reply',
        equipment:'equipment',
        submit_time:'Submit time',
        system_version:'System version',
        software_version:'Software version',
        read:'Read',
        reply:'reply',
        transfer_business:'Transfer to business',
        batch_mark_read:'Batch mark for read',
        batch_transfer_business:'Batch transfer to business',
        unknown_device:'unknown device',
      }
    },
    gold:{
      order:{
        gold_coin_trading_flow:'Gold coin trading flow',
      },
      package:{
        gold_coin_exchange:'Gold coin exchange',
        add_new_package:'Add new package',
        exchange_gold_coins_num:'Exchange of gold coins number',
        actual_price:'Actual price',
        package_name_id:'Package name or id',
        gold_num:'gold number',
        change_number:'Change number of people',
      }
    },
    user:{
      usercommenttable:{
        speaking_time:'speaking time',
        speech_content:'Speech content',
        speak_state:'speak state',
        has_shielding:'has been shielding',
        keyword_alarm:'Keyword alarm',
        unknown:'unknown',
      },
      userdetail:{
        details_personal_information:'Details of personal information',
        remove_gag:'Remove gag',
        user_gag:'User gag',
        enable_user:'Enable this user',
        disable_user:'Disable the user',
        gold_coin_water:'Gold coin use water',
        barrage_speak:'Barrage to speak',
        gender:'gender',
        equipment_info:'Equipment information',
        birthday:'birthday',
        client_version:'Client version',
        sign_id:'sign id',
        sign_location:'sign location',
        last_time_ip:'last time IP',
        last_login_time:'Last login time',
        last_location:'last location',
        phone:'Mobile phone',
        wechat_id:'WeChat ID',
        account_status:'Account status',
        microblog:'microblog',
        speech_situation:'Speech situation',
        android:'android',
        apple:'apple',
        unknown_system:'unknown system',
      },
      usergroup:{
        user_group_management:'User group management',
        add_group:'add group',
        number:'Number',
        creation_time:'Creation time',
        group_name:'Group name',
        condition:'Condition',
        current_user:'Current user',
        operation:'Operation',
        modify:'Modify',
        delete:'Delete',
        and:' and ',
        or:' or ',
        all_days:'All days ',
        lately:'Lately ',
        days:'days ',
      },
      userlist:{
        all_users:'all users',
        confirm_use:'Confirm to use',
        all_registered_users:'All registered users',
        sign_today:'sign today',
        all_vip:'All VIP',
        user_state:'User state',
      },
      whitelist:{
        total_number:'Total number',
        nickname_id:'Nickname or installation ID',
        user_nickname:'user nickname',
        remove:'remove',
      },
      whitelist2:{
        set_criteria:'set criteria',
        user_play_times:'The number of times the user has played for the last 30 days',
        time:'times',
        user_play_length:'The user plays the total length of the last 30 days',
        minutes:'minutes',
        save_set:'Save Settings',
        active_number:'Active number',
        white_list:'White list',
        average_playback_times:'Average playback times',
        average_playback_length:'Average playback length(M)',
        delete_from_list:'Delete from list',
      },
      whitelistadd:{
        determine:'Determine',
      },
      whitelistadd2:{
        enter_name_id:'Enter the user name or id',
        search:'search',
        user_label:'User label',
        white_list:'White list',
      },
      usergroupadd:{
        add_modify:'Add / modify user groups',
        group_name:'Group name',
        add_condition:'Add condition',
        intersection:'Intersection',
        aggregation:'Aggregation',
        time_frame:'time frame ',
        event:' event ',
        condition:' condition ',
        value:' value ',
        all_time:'All time',
        lately:'Lately',
        day:' days',
        yuan:' yuan ',
        percentile:'Percentile',
      }
    },
    devicelist:{
      devicerule:{
        blacklist_rule:"blacklist rule",
        blacklist_Id:"blacklist Id",
        type:"type",
        rule:"rule",
        creation_time:"creation time"
      },
    },
    vip:{
      addcode:{
        choose_existing_packages:'Choose existing packages',
        exchange_quota:'Single user exchange quota',
        allowable_exchange_time:'Allowable exchange time',
        end_exchange_time:'End the exchange time',
        modify_activation_code:'Modify activation code',
      },
      addvipset:{
        associated_existing_goods:'Associated with existing goods',
        add_goods:'Add goods',
        present_price:'Present price',
        membership_grade:'Membership grade',
        membership_days:'Membership days',
        total_package:'Total package',
        down_time:'Down time',
        product_number_name:'Enter a product number or name',
        commodity_number:'Commodity number',
        commodity_name:'Commodity name',
        gifts_gold_coins:'Gifts of gold coins',
        quantity_goods:'Quantity of goods',
        modify_package:'Modify the VIP package',
        new_package:'New VIP package',
        halt_sales:'halt the sales',
      },
      vipcodedetail:{
        activation_code_detail:'Member activation code detail',
        activation_time:'activation time',
        binding_package:'Binding package',
        total:'Total',
        already_activated:'Already activated',
        not_used:'not used',
        not_effect_time:'Not in effect time',
      },
      vipcodelist:{
        member_activation_code:'Member activation code',
        activation_code_name:'Activation code name',
        generated_time:'generated time',
        not_beginning_exchange:'Not beginning exchange',
        serial_number:'Serial number',
        start_exchange:'Start the exchange',
        end_exchange:'End the exchange',
        already_used:'Already used',
        use_detail:'Use detail',
      },
      viplist:{
        list:'list',
        add_icon:'Add icon',
      },
      vipmemberlist:{
        all_vip_members:'All VIP members',
        purchase_times:'Purchase times',
        initial_purchase_time:'Initial purchase time',
        this_purchase_time:'This purchase time',
      },
      viporderlist:{
        yuan:'yuan',
        vip_earnings:'Under the current conditions, the platform gains a total of VIP revenue',
        payment_method:'Method of payment',
        all:'all',
        gold_coin_payment:'Gold coin payment',
        alipay_pay:'Alipay to pay',
        wechat_pay:'WeChat pay',
        apple_purchase:'Apple purchase',
        activation_code_activation:'Activation code activation',
        transaction_serial_number:'transaction serial number',
        purchase_time:'Purchase time',
        package_name:'Package name',
        payment_amount:'payment amount',
        start_effective_time:'Start effective time',
      },
      vipserverlist:{
        welfare_set:'Welfare set',
        save_changes:'Save Changes',
      },
      vipsetlist:{
        package_management:'Package management',
        new_package:'new package',
        package_name_id:'Package name or ID',
        time_limit:'Time limit(day)',
        current_price:'current price',
        buy_limit:'buy limit',
      }
    }
  },
  log:{
    log:{
      test_log:'test log',
      phone_number:'phone number',
      historical_data:'historical data',
      empty:'empty',
      time:'time',
      event_time:'event time',
      user_id:'user id',
      video_id:'video id',
      event:'event',
      network:'network',
      client_system:'Client system',
      client_version:'Client version',
      app_version:'app version',
      start:'start',
      close:'close',
      collapse:'collapse',
      play:'play',
      start_playing:'start playing',
      resume_play:'resume play',
    }
  },
  media:{
    common:{
      name:'name',
      classification:'classification',
      select_file:'Select file',
      score:'score',
      publication_date:'Date of publication',
      cover:'cover',
      author:'author',
      names:'names',
      alias:'alias',
      operation:'operation',
      select:'select',
      add:'add',
      new:'new',
      look_current_folder:'Just look at the current folder',
      view_all:'View All',
      title:'title',
      state:'state',
      thumbnails:'thumbnails',
      intro:'intro',
      publish:'publish',
      withdraw:'withdraw',
      compile:'compile',
      shift_out:'shift out',
      del:'delete',
      batch_publish:'Batch publish',
      batch_withdraw:'Batch withdraw',
      batch_removal:'Batch removal',
      transcode_file_management:'Transcode file management',
      video_series_name:'Video/series name',
      all:'all',
      waiting_transcoding:'Waiting for transcoding',
      being_transcoding:'Being transcoding',
      transcoding_failure:'Transcoding failure',
      transcoding_abort:'Transcoding abort',
      transcoding_completion:'Transcoding completion',
      transcoding_scheme:'Transcoding scheme',
      video_name:'video name',
      series_name:'series name',
      transcoding_state:'Transcoding state',
      transcoding_progress:'Transcoding progress',
      format:'format',
      add_time:'add time',
      suspend:'suspend',
      unknown_state:'unknown state',
      upload_video:'Upload video',
      select_video_file:'Select the video file in the computer',
      selected_file:'Selected file',
      start_upload:'Start upload',
      filename:'file name',
      schedule:'schedule',
      creator:'creator',
      upload_time:'Upload time',
      continue_uploading:'Continue uploading',
      read_file_info:'The file information is being read...',
      read_infor_success:'Successful access to file information...',
      uploading:'uploading',
      uploaded:'uploaded',
      upload_error:'upload error',
      wait_uploading:'Wait for uploading',
      completed:'Completed',
      start_time:'start time',
      end_time:'end time',
      channel_name:'Channel name',
      describe:'describe',
      determine:'Determine',
      keywords:'keywords',
      online:'online',
      offline:'offline',
      artist:'artist',
      creation_time:'Creation time',
      click_selection:'Click selection',
      broadcast_address:'Broadcast address',
      edit_atlas_infor:'Edit the atlas information',
      news_headlines:'News headlines',
      source:'source',
      content:'content',
      time:'time',
      amend:'amend',
      sharpness:'sharpness',
      episode_list:'Episode list',
      catalogue_management:'Catalogue management',
      years:'s',
      years_ago:'years ago',
      pinyin:'pinyin',
      total_series:'total series',
      term_start:'term start',
      term_end:'term end',
      synopsis:'synopsis',
      video_thumbnail:'video thumbnail',
      ott_thumbnail:'ott thumbnail',
      add_watermark:'Add watermark',
      simplified_chinese:'Simplified Chinese',
      remove_from_group:'Remove from the resource group',
      please_check:'Please check!',
      published_status:'Published status!',
      withdrawn_release:'Withdrawn or pending release status!',
      view_folders:'view folders',
      amend_play:'Amend the play',
      transcoding_file:'Transcoding file',
      transcoding_again:'Transcoding again',
      preview:'preview',
      submit:'submit',
      add_resource_group:'Add resource group',
      nickname:'nickname',
      batch_add:'Batch add',
      cancel_set:'cancel set',
      publish_status:'publish status',
      picture_ratio:'picture ratio',
      address:'address',
      code_rate:'code rate',
      smooth:'Smooth',
      standard_definition:'SD',
      high_definition:'HD',
      ultra_hd:'ultra HD',
      source_id:'Source ID',
      source_name:'Source name',
      manual_sort:'Manual sort',
      cancel_manual_sort:'Cancel Manual sort',
      new_p2p_url:'New p2p url',
    },
    book:{
      book_detail:{
        edit_book_info:'Edit book information',
        books_file:'Books file',
        upload_files:'upload files',
        reupload_file:'Reupload file',
        press:'press',
        copyright_dealer:'Copyright dealer',
        book_description:'Book description',
      },
      book_list:{
        book_library:'Book library',
        num:'Number',
        ebook_size:'E-book size',
      }
    },
    image:{
      image_list:{
        image_library:'Image library',
        image_url:'Image url',
        file_type:'File type',
        file_size:'File size',
        updated_at:'Updated at'
      }
    },
    broadcast:{
      uploader:{
        batch_upload_video:'Batch upload video',
      }
    },
    epg:{
      add_pro:{
        program_name:'program name',
      },
      epg_change:{
        third_live_list:'Third party live list',
        provider:'provider',
      },
      list:{
        epg_management:'EPG management',
        new_epg:'New EPG',
        check_program_list:'Check out the program list',
      },
      program:{
        current_epg:'Current EPG',
        replace_epg:'Replace EPG',
        new_program:'new program',
        selection_time:'Selection time',
      },
      save:{
        program_document:'Program document',
        reselect:'reselect',
        uploading:'Uploading',
        epg_source:'EPG source',
        manually_uploading:'Manually uploading',
      }
    },
    music:{
      album_detail:{
        associated_songs_list:'List of associated songs',
        online_status:'Online status',
        remove:'remove',
        batch_remove:'Batch remove',
      },
      album_list:{
        album_management:'Album management',
        album_title:'Album Title',
        album_cover:'Album cover',
        view_all_songs:'View all the songs',
      },
      music_detail:{
        edit_music_info:'Edit music information',
        song_files:'Song files',
        song_name:'song name',
        song_time:'song time',
        source_album:'Source album',
        song_introduction:'Song introduction',
      },
      music_list:{
        music_library:'Music library',
        music_title:'Music title',
        album:'Album',
        duration:'duration',
      }
    },
    news:{
      article_detail:{
        enter_content:'Please enter content',
      },
      article_list:{
        article_lists:'article lists',
      },
      gallery_detail:{
        replace_cover:'Replace the cover',
        atlas:'atlas',
      },
      gallery_list:{
        atlas_list:'Atlas list',
      },
      news_setting:{
        series_matching:'series matching',
        corresponding_video:'Corresponding video',
        already_matched:'Already matched',
        not_match:'not match',
        matching_situation:'Matching situation',
        mobile_series:'Mobile TV series',
      }
    },
    resource_group:{
      common:{
        preview:{
          original_video:'original video',
        }
      },
      broadcast_detail:{
        add_attributes:'Add attributes',
      },
      broadcast_list:{
        add_existing_broadcast:'Add existing broadcast',
        create_new_broadcast:'Create new broadcast',
        broadcast_name:'broadcast name',
      },
      episode_add:{
        create_series:'Create series',
        upper_level:'Upper level',
        return_root:'Return to root',
        batch_select:'Batch select',
      },
      episode_list_table:{
        watermark:'watermark',
      },
      episode_list:{
        add_series:'Add series',
        sort_save:'sort save',
        reverse_sort:'Reverse sort',
        del_diversity:'Delete diversity',
      },
      group_add:{
        new:'new',
        resource_group:'resource group',
      },
      group_list_tree:{
        del_resource_group:'Delete resource group',
        edit_resource_group:'Edit resource group',
      },
      group_list:{
        all:'all',
        not_grouped:'Not grouped',
      },
      video_add:{
        new_dibble_seeding_video:'New dibble seeding video',
        total_episodes:'Total number of episodes',
      },
      video_detail:{
        reverse_order_series:'The reverse order of the series',
        yes:'yes',
        no:'no',
        without:'without',
      },
      video_list:{
        add_existing_video:'Add existing video',
        create_new_video:'Create new video',
        add_filter_box:'Add filter box',
        series_num:'series number',
        occupy_space:'Occupy space',
        total_time:'total time',
        transcode_file_number:'Transcode file number',
        series:'series',
        publish:'publish',
        conditional_video:'Conditional video',
      },
      video_property:{
        check_all:'check all',
      },
      video_push:{
        add_already_video:'Add dibble seeding video already',
        sort_time:'Sort time',
        release_time:'Release time',
        update_time:'Update time',
        existing_total_series:'Existing/total series',
      }
    },
    source:{
      add:{
        width_height:'width x height',
      },
      list:{
        source_management:'Source management',
        add_source:'Add Source',
        modification_time:'Modification time',
      }
    },
    stream:{
      add:{
        edit_channel:'Edit channel',
        modification_basic_info:'Modification basic information',
        save_basic_info:'Save basic information',
        clients:'Clients',
        select_cp:'Select cp',
        affiliated_area:'Affiliated area',
        nationwide:'Nationwide',
        area:'Area',
        select_area:'Select area',
        refresh_area:'Refresh area',
        class_label:'Classification & label',
        source_config:'Source configuration',
        program_management:'Program management',
        access_mode:'Access mode',
        bit_rate:'Bit rate',
        proportion:'Proportion',
      },
      list:{
        resource_library:'Resource library',
        add_existing_channels:'Add existing channels',
        new_channel:'New channel',
        whether_associate_epg:'Whether or not to associate EPG',
        published:'Published',
        withdrawn:'Withdrawn',
        deleted:'Deleted',
        draft:'Draft',
      }
    },
    video:{
      transcoding:{
        pause_transcoding:'Pause transcoding',
      }
    },
    list:{
      feedback_problem:'Feedback problem',
      user_name:'User name',
      replied:'Replied',
      unanswered:'Unanswered',
      have_read_unanswered:'Have read unanswered',
      platform:'Platform',
      equipment:'Equipment',
      user_id:'User id',
      system_version:'System version',
      software_version:'Software version',
      have_read:'Have read',
      reply:'Reply',
      transfer_business:'Transfer to business',
      batch_mark_read:'Batch mark is read',
      batch_transfer_business:'Batch transfer to business',
      unknown_device:'Unknown device',
    },
    property:{
      attribute:'Attribute',
      code:'Code',
      identity:'Identity',
    }
  },
  product:{
    common:{
      product_name:'Product name',
      internal_goods:'Internal goods',
      external_goods:'External goods',
      cash_income:'Cash income',
      gold_income:'Gold income',
    },
    add:{
      new_goods:'New goods',
      product_category:'Product category',
      selection_platform:'Selection platform',
      associated_internal_purchase:'Associated with internal purchase',
      total_goods:'Total goods',
      shelf_time:'Shelf time',
      down_time:'Down time',
      rights_interests_set:'Rights and interests setting',
      gold_num:'Gold coin number',
      length:'Length(day)',
      purchase_method:'Purchase method',
      cash_amount:'Cash amount',
      gold_coin_amount:'Gold coin amount',
      commodity_description:'Commodity description',
    },
    list:{
      all_goods:'All goods',
      new_goods:'New goods',
      state:'State',
      all:'All',
      putaway:'Putaway',
      already_down:'Already down',
      category:'Category',
      up_down_state:'Up and down state',
      product_id:'Product id',
      selling_state:'Selling state',
      sold_num:'Sold number',
      operation:'Operation',
      take_effect:'Take effect',
      off_shelf:'Off the shelf',
      start_use:'Start use',
      disable:'Disable',
      check_details:'Check the details',
      compile:'Compile',
      del:'Delete',
      stop_selling:'Stop selling',
      is_selling:'Is selling',
    },
    order:{
      commodity_trading_details:'Commodity trading details',
      purchase_time:'Purchase time',
      transaction_num:'Transaction number',
      purchase_users:'Purchase of users',
    }
  },
  source:{
    common:{
      select_time:'Select time',
      add:'Add',
      name:'Name',
      state:'State',
      start_use:'Start use',
      disable:'Disable',
      running_state:'Running state',
      running:'Running',
      not_running:'Not running',
      operation:'Operation',
      amend:'Amend',
      del:'Delete',
    },
    event_list:{
      event_management:'Event management',
      message:'Message',
      warning:'Warning',
      error:'Error',
      live_stream_name:'Live stream name',
      content:'Content',
      level:'Level',
      live_stream_id:'Live stream ID',
      server:'Server',
      appearance_time:'Time of appearance',
    },
    live_list:{
      live_source_management:'Live source management',
      host:'Host',
      live_streaming:'Live streaming',
      view_events:'View events',
    },
    stream_list:{
      flow_column:'Flow column management',
      whether_transform_save:'Whether transform save',
      yes:'Yes',
      no:'No',
      whether_main_source:'Whether the main source',
      source_address:'Source address',
      resolution:'Resolution',
      video_bitrate:'Video bit rate',
      audio_bitrate:'Audio bit rate',
      publish_address:'Publish address',
      all_ts_files:'All ts files',
      start_running:'Start running',
      stop_running:'Stop running',
    },
    ts_list:{
      ts_file_list:'Ts file list',
      file_name:'File name',
      path:'Path',
      file_size:'File size',
      start_time:'Start time',
      time_length:'Time length',
      whether_synchronization:'Whether the synchronization',
      creation_time:'Creation time',
      update_time:'Update time',
    }
  },
  login:{
    chinatv_system:'ChinaTV management system',
    user_name:'User name',
    password:'Password',
    remember_password:'Remember password',
    login:'Login',
  }
}
